import React from "react";
import { Linking } from "react-native";
import alert from "./alert";

export default (url) => {
  window.open(url);
};
